// VivaBalance — scripts propios (vanilla, sin librerías)
document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initMarquesina();
  initGaleriaProducto();
  initVariantesProducto();
  initFaq();
  initAntesDespues();
});

function initAntesDespues() {
  document.querySelectorAll('[data-vb-antes-despues]').forEach(function (wrap) {
    var cont = wrap.querySelector('[data-vb-antes-cont]');
    var linea = wrap.querySelector('[data-vb-linea]');
    var asa = wrap.querySelector('[data-vb-asa]');
    var slider = wrap.querySelector('[data-vb-slider]');
    if (!cont || !slider) return;

    function actualizar(pct) {
      pct = Math.max(0, Math.min(100, pct));
      cont.style.width = pct + '%';
      linea.style.left = pct + '%';
      asa.style.left = pct + '%';
      slider.value = pct;
    }

    slider.addEventListener('input', function () { actualizar(Number(slider.value)); });

    var arrastrando = false;
    function pctDesdeEvento(clientX) {
      var rect = wrap.querySelector('.vb-ad-imagenes').getBoundingClientRect();
      return ((clientX - rect.left) / rect.width) * 100;
    }
    asa.addEventListener('pointerdown', function () { arrastrando = true; });
    window.addEventListener('pointerup', function () { arrastrando = false; });
    window.addEventListener('pointermove', function (e) {
      if (!arrastrando) return;
      actualizar(pctDesdeEvento(e.clientX));
    });

    actualizar(50);
  });
}

function initReveal() {
  var els = document.querySelectorAll('.vb-reveal, .vb-reveal-scale');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('vb-visible'); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var delay = entry.target.getAttribute('data-vb-delay') || 0;
        setTimeout(function () { entry.target.classList.add('vb-visible'); }, Number(delay));
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
  els.forEach(function (el) { obs.observe(el); });
}

function initMarquesina() {
  document.querySelectorAll('[data-vb-marquesina]').forEach(function (wrap) {
    var pista = wrap.querySelector('.vb-marquesina-pista');
    if (!pista) return;
    var velocidad = wrap.getAttribute('data-velocidad') || '28';
    pista.style.animationDuration = velocidad + 's';
  });
}

function initGaleriaProducto() {
  var galeria = document.querySelector('[data-vb-galeria]');
  if (!galeria) return;
  var principal = galeria.querySelector('[data-vb-imagen-principal]');
  var minis = galeria.querySelectorAll('[data-vb-mini]');
  var videoWraps = galeria.querySelectorAll('[data-vb-video-wrap]');
  if (!principal || !minis.length) return;

  function ocultarVideos() {
    videoWraps.forEach(function (wrap) {
      wrap.hidden = true;
      var video = wrap.querySelector('video');
      if (video) video.pause();
    });
    principal.style.display = '';
  }

  minis.forEach(function (mini) {
    mini.addEventListener('click', function () {
      minis.forEach(function (m) { m.classList.remove('vb-mini-activa'); });
      mini.classList.add('vb-mini-activa');

      if (mini.getAttribute('data-tipo') === 'video') {
        var mediaId = mini.getAttribute('data-media-id');
        videoWraps.forEach(function (wrap) {
          var esEste = wrap.getAttribute('data-media-id') === mediaId;
          wrap.hidden = !esEste;
          if (!esEste) {
            var v = wrap.querySelector('video');
            if (v) v.pause();
          }
        });
        principal.style.display = 'none';
      } else {
        ocultarVideos();
        var src = mini.getAttribute('data-full');
        principal.src = src;
        principal.setAttribute('srcset', src);
      }
    });
  });
}

function initVariantesProducto() {
  var form = document.querySelector('[data-vb-form-producto]');
  if (!form) return;
  var dataEl = document.querySelector('[data-vb-variantes-json]');
  var grupos = form.querySelectorAll('[data-vb-grupo-opcion]');
  if (!dataEl || !grupos.length) return;
  var variantes;
  try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

  function valorDeGrupo(grupo) {
    var sel = grupo.querySelector('select[data-vb-opcion]');
    if (sel) return sel.value;
    var radio = grupo.querySelector('input[type=radio][data-vb-opcion]:checked');
    return radio ? radio.value : null;
  }

  function variantePorOpciones() {
    var valores = Array.from(grupos).map(valorDeGrupo);
    return variantes.find(function (v) {
      return v.options.every(function (opt, i) { return opt === valores[i]; });
    });
  }

  function actualizarTarjetasActivas() {
    form.querySelectorAll('.vb-cantidad-card').forEach(function (card) {
      var input = card.querySelector('input[type=radio]');
      card.classList.toggle('vb-cantidad-activa', !!(input && input.checked));
    });
  }

  function actualizar() {
    var variante = variantePorOpciones();
    if (!variante) return;
    var inputId = form.querySelector('input[name="id"]');
    if (inputId) inputId.value = variante.id;
    var precioEl = document.querySelector('[data-vb-precio]');
    var comparadoEl = document.querySelector('[data-vb-precio-comparado]');
    if (precioEl) precioEl.textContent = formatoDinero(variante.price);
    if (comparadoEl) {
      if (variante.compare_at_price && variante.compare_at_price > variante.price) {
        comparadoEl.textContent = formatoDinero(variante.compare_at_price);
        comparadoEl.style.display = '';
      } else {
        comparadoEl.style.display = 'none';
      }
    }
    var boton = form.querySelector('[data-vb-boton-comprar]');
    if (boton) {
      if (variante.available) {
        boton.disabled = false;
        boton.textContent = boton.getAttribute('data-texto-disponible');
      } else {
        boton.disabled = true;
        boton.textContent = boton.getAttribute('data-texto-agotado');
      }
    }
    actualizarTarjetasActivas();
  }

  function formatoDinero(centavos) {
    var val = (centavos / 100).toLocaleString('es-CO', { minimumFractionDigits: 0 });
    return '$' + val;
  }

  form.addEventListener('change', function (e) {
    if (e.target.matches('[data-vb-opcion]')) actualizar();
  });
}

function initFaq() {
  document.querySelectorAll('[data-vb-faq-item]').forEach(function (item) {
    var pregunta = item.querySelector('[data-vb-faq-pregunta]');
    if (!pregunta) return;
    pregunta.addEventListener('click', function () {
      var abierto = item.classList.contains('vb-faq-abierta');
      item.closest('[data-vb-faq-lista]').querySelectorAll('[data-vb-faq-item]').forEach(function (i) {
        i.classList.remove('vb-faq-abierta');
      });
      if (!abierto) item.classList.add('vb-faq-abierta');
    });
  });
}
